function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.534 9H9.502a.5.5 0 00-.447.726l3.298 6.523-3.299 6.525a.5.5 0 00.447.726h13.032a.5.5 0 00.446-.726l-3.297-6.523 3.298-6.525A.5.5 0 0022.534 9z",
  fill: "#B8C3D9"
});

var SvgIconBowNormal = function SvgIconBowNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjIuNTMzOCA5SDkuNTAxNjFDOS4xMjkwNSA5IDguODg3MzYgOS4zOTI5NCA5LjA1NTMyIDkuNzI1NTlMMTIuMzUyNyAxNi4yNDlMOS4wNTQzNSAyMi43NzQ0QzguODg2MzggMjMuMTA3MSA5LjEyODA4IDIzLjUgOS41MDA2NCAyMy41SDE2LjAxNzdIMjIuNTMyOUMyMi45MDU0IDIzLjUgMjMuMTQ3MSAyMy4xMDcxIDIyLjk3OTIgMjIuNzc0NEwxOS42ODE4IDE2LjI1MUwyMi45ODAxIDkuNzI1NTlDMjMuMTQ4MSA5LjM5Mjk0IDIyLjkwNjQgOSAyMi41MzM4IDlaIiBmaWxsPSIjQjhDM0Q5Ii8+Cjwvc3ZnPgo=";
export { SvgIconBowNormal as ReactComponent };